// extracted by mini-css-extract-plugin
export default {"containerView":"ContractsView_containerView__qi4+A","collabsCard":"ContractsView_collabsCard__nGQ9b","linkStyle":"ContractsView_linkStyle__qpeGA"};